
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountriesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryFilters"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ar"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tr"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"symbol"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ar"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tr"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"decimalPlace"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lowestDenomination"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isoCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dialCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flagPhoto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"locationsRadius"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"serviceFee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"servicePhoneNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minimumDeliveryOrderAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vatId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasVat"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timeZoneIdentifier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timeZoneOffset"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":482}};
    doc.loc.source = {"body":"query CountriesQuery($filters: CountryFilters) {\n  countries(filters: $filters) {\n    id\n    name {\n      en\n      ar\n      tr\n    }\n    status\n    currency {\n      id\n      name\n      symbol {\n        en\n        ar\n        tr\n      }\n      decimalPlace\n      lowestDenomination\n    }\n    isoCode\n    dialCode\n    flagPhoto\n    locationsRadius\n    serviceFee\n    servicePhoneNumber\n    minimumDeliveryOrderAmount\n    vatId\n    hasVat\n    timeZoneIdentifier\n    timeZoneOffset\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CountriesQuery"] = oneQuery(doc, "CountriesQuery");
        
